import React from "react";
import { Link } from "react-router-dom";
import whiteUpArrow from '../../assets/img/icons/white-up-arrow.svg';
import linkIcon from '../../assets/img/icons/link.svg';
import circularPattern from '../../assets/img/logos/circular-m-pattern-small.svg';

const ExternalLinkIcon = () => (
    <img
        src={linkIcon}
        alt="Link"
        width="13"
        height="13"
        className="img-fluid ms-2"
        loading="lazy"
        fetchPriority="low"
    />
);

const footerColumns = [
    {
        heading: 'General',
        links: [
            { label: 'Home', href: 'https://motabilityschemelive.co.uk/', external: false },
            { label: 'Join our mailing list', href: 'https://motabilityschemelive.co.uk/join-our-mailing-list/', external: false },
        ],
    },
    {
        heading: 'Help and Contact',
        links: [
            { label: 'Contact us', href: 'https://motabilityschemelive.co.uk/contact-us/', external: false },
        ],
    },
    {
        heading: 'Terms',
        links: [
            { label: 'Terms and conditions', href: 'https://www.motability.co.uk/utilities/terms-and-conditions', external: true },
            { label: 'Privacy notice', href: 'https://www.motability.co.uk/utilities/privacy-notice', external: true },
            { label: 'Cookies policy', href: 'https://www.motability.co.uk/utilities/cookies-policy', external: true },
            { label: 'Accessibility', href: 'https://www.motability.co.uk/utilities/accessibility', external: true },
        ],
    },
    {
        heading: 'Links',
        links: [
            { label: 'Motability Scheme website', href: 'https://www.motability.co.uk/', external: true },
        ],
    },
];

const Footer = () => {
    return (
        <footer className="bg-primary position-relative" id="main-footer">
            <div className="container-xxl-1152 py-5 pt-lg-96 position-relative">
                <Link 
                    to="#body-container" 
                    className="d-flex align-items-center justify-content-center w-48 h-48 bg-secondary rounded-circle border border-motability-white position-absolute top-0 end-50 end-xl-0 translate-middle-50" 
                    title="Back to top"
                >
                    <img
                        src={whiteUpArrow}
                        alt="White up arrow"
                        width="16"
                        height="18"
                        loading="lazy"
                        fetchPriority="low"
                    />
                </Link>

                <div className="row">
                    {footerColumns.map((column) => (
                        <div key={column.heading} className="col-6 col-sm mb-4 mb-sm-5 mb-lg-87">
                            <h6 className="fw-medium text-motability-white lh-125 mb-3 mb-lg-24">
                                {column.heading}
                            </h6>
                            <nav className="footer-nav-links">
                                <ul className="list-unstyled mb-0">
                                    {column.links.map((link) => (
                                        <li key={link.label}>
                                            <a
                                                href={link.href}
                                                className="text-decoration-none d-inline-flex align-items-center text-motability-white small"
                                                {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                                            >
                                                {link.label}
                                                {link.external && <ExternalLinkIcon />}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </div>
                    ))}
                </div>

                <div className="row" id="bottom-bar">
                    <div className="col-sm-6 col-xxl-7 mb-4 mb-sm-0" id="bottom-bar-text">
                        <p>
                            The Motability Scheme is run by <a href="https://www.mo.co.uk/" target="_blank" rel="noopener noreferrer">Motability Operations Ltd</a>, 
                            under a contract to <a href="https://www.motabilityfoundation.org.uk/" target="_blank" rel="noopener noreferrer">Motability</a>, 
                            a registered charity.
                        </p>

                        <p>
                            Motability Operations Ltd is authorised and regulated by the Financial Conduct Authority under 
                            reference number 735390. See our <Link to="/terms-and-conditions">terms and conditions</Link> for 
                            more information.
                        </p>
                    </div>

                    <div className="col-sm">
                        <div className="footer-social-icons d-flex align-items-center justify-content-center justify-content-sm-end gap-4">
                            <a href="https://www.youtube.com/c/MotabilitySchemeOfficial" className="social-icon text-decoration-none d-inline-block" target="_blank" rel="noopener noreferrer">
                                <i className="icon-youtube text-motability-white fs-32" aria-hidden="true"></i>
                                <span className="visually-hidden">YouTube</span>
                            </a>

                            <a href="https://www.instagram.com/motabilityscheme/" className="social-icon text-decoration-none d-inline-block" target="_blank" rel="noopener noreferrer">
                                <i className="icon-instagram text-motability-white fs-32" aria-hidden="true"></i>
                                <span className="visually-hidden">Instagram</span>
                            </a>

                            <a href="https://www.facebook.com/motability" className="social-icon text-decoration-none d-inline-block" target="_blank" rel="noopener noreferrer">
                                <i className="icon-facebook text-motability-white fs-32" aria-hidden="true"></i>
                                <span className="visually-hidden">Facebook</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <img
                src={circularPattern}
                alt="A circular pattern made of repeating M letters"
                className="img-fluid position-absolute top-50 end-0 translate-middle-y pe-none opacity-50 opacity-xxl-100 d-none d-xl-block"
                width="254"
                height="381"
                loading="lazy"
                fetchPriority="low"
            />
        </footer>
    );
};

export default Footer; 